import React from 'react';

export function Spinner({ size = 24 }) {
  return (
    <div
      data-testid="spinner"
      style={{ width: size, height: size, borderWidth: Math.max(2, size / 12) }}
      className="rounded-full border-white/10 border-t-[#D4AF37] animate-spin"
    />
  );
}
